module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [(!_vm.loading) ? _c('multiselect', {
    attrs: {
      "options": _vm.requirements,
      "multiple": true,
      "custom-label": _vm.customRequirementLabel,
      "close-on-select": true,
      "clear-on-select": false,
      "hide-selected": true,
      "placeholder": "Link requirements to issue",
      "track-by": "requirement_id"
    },
    model: {
      value: (_vm.selectedRequirements),
      callback: function($$v) {
        _vm.selectedRequirements = $$v
      },
      expression: "selectedRequirements"
    }
  }) : (_vm.loading) ? _c('div', [_c('div', {
    staticClass: "d-flex justify-content-center align-items-center"
  }, [_c('icon', {
    attrs: {
      "name": "spinner",
      "pulse": "",
      "scale": "5"
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77f9b1aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/LinkRequirementsDialog.vue
// module id = 1019
// module chunks = 1